import * as plugins from '@wix/auto_sdk_site-plugins_plugins';

export { plugins };
